module.exports = __webpack_public_path__ + "img/1510524636.f8010d64.jpg";